import { IUser } from '../../modules/Auth/models/user.model';

const idsDisable: any = ['6021df41cdfa730e27e5f98a'];

export const loadScriptCubos = (user: IUser | null) => {
  try {
    if (user && user.id && user.email && !idsDisable.includes(user.id)) {
      const script = document.createElement('script');
      script.src = 'https://tools.cubos.academy/widgets/emy.js';
      script.type = 'text/javascript';
      script.async = true;
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    }
  } catch (e) {
    console.log('Error cubos');
  }

  return null;
};
